import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';
import { installConsoleProxy, registerLogSink } from './utils/logger';
import { OpenObserveSink, readOpenObserveConfig } from './utils/openobserve';
// 仅在生产代理全局 console
if (process.env.NODE_ENV === 'production') {
  installConsoleProxy();
}

// 初始化 OpenObserve sink（按需启用）
try {
  const ooConfig = readOpenObserveConfig();
  if (ooConfig.enabled && ooConfig.baseUrl && ooConfig.organization) {
    registerLogSink(new OpenObserveSink(ooConfig));
    console.info('[OpenObserve] sink registered');
  }
} catch {}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// 标记预渲染已就绪（供 prerender 脚本等待）
try {
  if (typeof window !== 'undefined') window.__PRERENDER_READY__ = true;
} catch {}